import { useEffect, useState } from "react";
import { api } from "@/lib/api";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";

function fullUrl(u) {
  if (!u) return "";
  return u.startsWith("/api/") ? `${BACKEND_URL}${u}` : u;
}

/**
 * Renderuje wszystkie widoczne grafiki dla danej podstrony w pozycjach absolutnych.
 * Kontener rodzica MUSI mieć `position: relative` (page container już jest).
 *
 * Placementy pobierane z /api/page-placements/{page}.
 * Każdy placement ma: top_px, left_pct, width_px, rotation, z_index.
 */
export default function PagePlacements({ page }) {
  const [placements, setPlacements] = useState([]);

  useEffect(() => {
    let alive = true;
    api.get(`/page-placements/${encodeURIComponent(page)}`)
      .then((r) => { if (alive) setPlacements(r.data || []); })
      .catch(() => {});
    return () => { alive = false; };
  }, [page]);

  if (!placements.length) return null;

  return (
    <>
      {placements.map((p) => (
        <img
          key={p.id}
          src={fullUrl(p.url)}
          alt={p.alt || ""}
          loading="lazy"
          data-testid={`placement-${p.id}`}
          style={{
            position: "absolute",
            top: `${p.top_px}px`,
            left: `${p.left_pct}%`,
            width: `${p.width_px}px`,
            transform: `translateX(-50%) rotate(${p.rotation || 0}deg)`,
            zIndex: p.z_index || 20,
            pointerEvents: "none",   // nie blokuj klików w tekst pod spodem
            userSelect: "none",
          }}
        />
      ))}
    </>
  );
}
